import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SERVICES } from "@/pages/public/Home";

const DETAILS = {
  "centro-usinagem": [
    "Centros verticais Romi Discovery 600/560 e Eurostec MCV520",
    "Peças seriadas e protótipos",
    "Tolerâncias de até ±0,01 mm",
    "Aço, inox, alumínio, latão e polímeros",
  ],
  torneamento: [
    "Eixos, buchas e anéis",
    "Roscas internas e externas",
    "Recuperação de componentes",
    "Peças unitárias ou em série",
  ],
  plasma: [
    "Leitura direta de arquivos DXF",
    "Chapas de aço carbono, inox e alumínio",
    "Cortes retos e perfilados",
    "Aproveitamento otimizado de chapa",
  ],
  dobra: [
    "Dobra de chapas até 2,0 mm de espessura",
    "Precisão conforme especificação do projeto",
    "Peças e componentes sob desenho",
    "Integrada ao corte plasma e laser",
  ],
  jateamento: [
    "Jateamento de peças e componentes metálicos",
    "Preparação e acabamento de superfícies",
    "Orçamento com análise de complexidade e fotos",
    "Peças sob desenho e especificação do projeto",
  ],
  fresamento: [
    "Rasgos, canais e cavidades",
    "Superfícies planas e perfiladas",
    "Furação e mandrilamento",
    "Dispositivos e gabaritos",
  ],
  "gravacao-laser": [
    "Marcação permanente de peças",
    "Números de série e códigos",
    "Logotipos e identificação",
    "Alta definição sem contato",
  ],
  solda: [
    "Processos MMA, MIG e TIG",
    "Estruturas metálicas",
    "Conjuntos e subconjuntos soldados",
    "Reparos e manutenção industrial",
  ],
  "serra-fita": [
    "Barras, tubos e perfis",
    "Cortes com esquadria",
    "Corte em ângulo",
    "Preparação de material para usinagem",
  ],
};

export default function Servicos() {
  return (
    <div className="pt-[72px]" data-testid="servicos-page">
      <section className="py-20 border-b border-zinc-800 bg-zinc-900/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center gap-3 mb-3">
            <span className="h-px w-10 bg-orange-500" />
            <span className="mono text-xs uppercase tracking-[0.35em] text-orange-400">capacidade produtiva</span>
          </div>
          <h1 className="display text-4xl sm:text-6xl font-extrabold uppercase">Nossos Serviços</h1>
          <p className="mt-4 text-zinc-400 max-w-2xl text-sm sm:text-base leading-relaxed">
            Do corte da chapa ao acabamento final, executamos todo o processo dentro
            da nossa própria estrutura — menos prazo, mais controle de qualidade.
            Trabalhamos também com peças sob desenho.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid md:grid-cols-2 gap-6">
          {SERVICES.map((s) => (
            <article
              key={s.slug}
              id={s.slug}
              data-testid={`servico-${s.slug}`}
              className="scroll-mt-24 card-tactical rounded-md p-8 hover:border-orange-900/60 transition-colors"
            >
              <div className="flex items-start gap-5">
                <div className="shrink-0 w-14 h-14 grid place-content-center border border-zinc-700 rounded-sm bg-zinc-900">
                  <s.icon className="w-7 h-7 text-orange-500" strokeWidth={1.5} />
                </div>
                <div>
                  <h2 className="display text-2xl font-bold uppercase tracking-wide">{s.title}</h2>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
                  {s.highlight && (
                    <span
                      data-testid={`servico-destaque-${s.slug}`}
                      className="mt-3 inline-block border border-orange-500/70 bg-orange-500/10 text-orange-400 text-sm font-extrabold uppercase tracking-[0.2em] px-3.5 py-1.5 rounded-sm"
                    >
                      {s.highlight}
                    </span>
                  )}
                </div>
              </div>
              <ul className="mt-6 grid sm:grid-cols-2 gap-2.5">
                {DETAILS[s.slug].map((d) => (
                  <li key={d} className="flex items-start gap-2 text-sm text-zinc-400">
                    <Check className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />{d}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <p className="text-zinc-400 text-sm">Não encontrou o que procura? Fale conosco — avaliamos qualquer projeto.</p>
          <Link
            to="/painel/orcamentos/novo"
            data-testid="servicos-quote-button"
            className="mt-5 inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-500 text-white font-semibold uppercase tracking-wider px-7 py-3.5 rounded-sm transition-colors"
          >
            Solicitar orçamento <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
